import CSSclasses from '../../cart.scss';
export const getTitleClasses = () => CSSclasses.title;
export const getItemQuantClasses = () => CSSclasses.itemsQuantity;